export const MAX_VALUE_UINT256 =
  '115792089237316195423570985008687907853269984665640564039457584007913129639935';
export const TOTAL_REWARD_AMOUNT = '1.2';
export const MAX_LTV_RATIO = 50;
export const LIQUIDATION_RATIO = 95;
